import classnames from 'classnames/bind'
import { useTranslate } from 'react-polyglot'
import { GlobalThemeColors } from '~/@types/colors'
import { GlobalTextPreset } from '~/@types/text-preset'
import { SINGLE_ROUTES } from '~/lib/constants'

import { useLogout } from '@unlikelystudio/react-ecommerce-hooks'

import InlineCta from '~/components/UI/InlineCta'

import useSingleRoutesRedirect from '~/hooks/useSingleRoutesRedirect'

import { ACCOUNT } from '~/data/dictionary'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export const AccountNavigationSections = {
  ADDRESS_BOOK: 'address-book',
  INFORMATION: 'information',
  LOGOUT: 'logout',
  ORDERS: 'orders',
  RETURNS: 'returns',
} as const

export type AccountNavigationSections =
  typeof AccountNavigationSections[keyof typeof AccountNavigationSections]

type AccountNavigationItemProps = {
  label?: string
  section?: AccountNavigationSections
}

export type AccountNavigationProps = {
  className?: string
  activeSection: AccountNavigationSections
  setSection: (section: AccountNavigationSections) => void
  items: AccountNavigationItemProps[]
}

function AccountNavigation({
  className,
  activeSection,
  setSection,
  items,
}: AccountNavigationProps) {
  const t = useTranslate()
  const redirect = useSingleRoutesRedirect()

  const handleLogout = useLogout({
    onLogout: () => redirect(SINGLE_ROUTES.login),
  })

  return (
    <nav className={cx(className, css.AccountNavigation)}>
      <ul className={css.links}>
        {items?.map(({ label, section }) => {
          const isActive = activeSection && activeSection === section
          const theme = isActive
            ? GlobalThemeColors.Black
            : GlobalThemeColors.Gray
          const Tag = isActive ? 'h1' : 'span'
          return (
            <li
              key={`accountNavigationItem${screen}${section}${activeSection}`}
              className={css.link}>
              <InlineCta
                onClick={() => setSection(section)}
                textPreset={GlobalTextPreset.Cta12Grotesk}
                theme={theme}
                lineProps={{ initialLineState: 'none' }}
                forcedUnderlined={isActive}>
                <Tag>{label}</Tag>
              </InlineCta>
            </li>
          )
        })}
        <li className={css.link}>
          <InlineCta
            lineProps={{ initialLineState: 'none' }}
            textPreset={GlobalTextPreset.Cta12Grotesk}
            theme={GlobalThemeColors.Gray}
            onClick={handleLogout}>
            {t(ACCOUNT.LOGOUT)}
          </InlineCta>
        </li>
      </ul>
    </nav>
  )
}

AccountNavigation.defaultProps = {}

export default AccountNavigation
